document.addEventListener('DOMContentLoaded', function () {
  var strings = window.CocoonHavenStrings || {};
  var t = {
    addToCart: strings.addToCart || 'Add to bag',
    adding: strings.adding || 'Adding…',
    added: strings.added || 'Added to bag',
    soldOut: strings.soldOut || 'Sold out',
    unavailable: strings.unavailable || 'Unavailable',
    savePrefix: strings.savePrefix || 'Save'
  };

  var menuButton = document.querySelector('.menu-toggle');
  var menu = document.getElementById('PrimaryNav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('.acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      item.classList.toggle('open');
      var body = item.querySelector('.acc-body');
      if (body) body.style.maxHeight = item.classList.contains('open') ? body.scrollHeight + 'px' : '';
    });
    var initialItem = head.parentElement;
    var initialBody = initialItem.querySelector('.acc-body');
    if (initialBody && initialItem.classList.contains('open')) initialBody.style.maxHeight = initialBody.scrollHeight + 'px';
  });

  document.querySelectorAll('.filter-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      var row = pill.closest('.filter-row');
      if (!row) return;
      row.querySelectorAll('.filter-pill').forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
    });
  });

  document.querySelectorAll('[data-scroll-to-atc]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector('[data-product-root] .btn-add') || document.querySelector('.btn-add');
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var sectionId = root.getAttribute('data-product-root');
    var form = root.querySelector('form.product-form');
    var dataNode = document.getElementById('ProductVariants-' + sectionId);
    if (!form || !dataNode) return;

    var variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
    var selected = [];
    root.querySelectorAll('.option-block').forEach(function (block) {
      var index = Number(block.dataset.optionIndex);
      var active = block.querySelector('.option-value-btn.active');
      if (active) selected[index] = active.dataset.value;
    });

    function findVariant(selection) {
      selection = selection || selected;
      if (variants.length === 1) return variants[0];
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return selection[index] === value; });
      });
    }

    function formatMoneyFallback(cents) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    }

    function updateOptionAvailability() {
      root.querySelectorAll('.option-value-btn').forEach(function (button) {
        var index = Number(button.dataset.optionIndex);
        var test = selected.slice();
        test[index] = button.dataset.value;
        var possible = variants.some(function (variant) {
          return variant.available && variant.options.every(function (value, i) { return test[i] === value; });
        });
        button.classList.toggle('disabled', !possible);
        button.disabled = !possible;
      });
    }

    function setVariant(variant) {
      var idInput = document.getElementById('variantIdInput-' + sectionId);
      var price = document.getElementById('price-' + sectionId);
      var compare = document.getElementById('comparePrice-' + sectionId);
      var save = document.getElementById('saveBadge-' + sectionId);
      var atc = document.getElementById('mainAtc-' + sectionId);
      var stickyPrice = document.getElementById('stickyPrice-' + sectionId);
      var stickyVariant = document.getElementById('stickyVariant-' + sectionId);
      var mainImage = document.getElementById('mainImage-' + sectionId);
      var sticky = document.getElementById('stickyAtc-' + sectionId);
      var stickyButton = sticky && sticky.querySelector('[data-sticky-submit]');

      if (!variant) {
        if (atc) { atc.disabled = true; atc.textContent = t.unavailable; }
        if (stickyButton) { stickyButton.disabled = true; stickyButton.textContent = t.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = variant.priceFormatted;
      if (stickyPrice) stickyPrice.textContent = variant.priceFormatted;
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (compare) {
        if (variant.compareAt > variant.price) { compare.hidden = false; compare.textContent = variant.compareAtFormatted; }
        else compare.hidden = true;
      }
      if (save) {
        if (variant.compareAt > variant.price) {
          save.hidden = false;
          save.textContent = t.savePrefix + ' ' + formatMoneyFallback(variant.compareAt - variant.price);
        } else save.hidden = true;
      }
      if (atc) { atc.disabled = !variant.available; atc.textContent = variant.available ? t.addToCart : t.soldOut; }
      if (stickyButton) { stickyButton.disabled = !variant.available; stickyButton.textContent = variant.available ? t.addToCart : t.soldOut; }
      if (mainImage && variant.featuredImage) mainImage.src = variant.featuredImage;
    }

    root.querySelectorAll('.option-value-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var index = Number(button.dataset.optionIndex);
        selected[index] = button.dataset.value;
        var block = button.closest('.option-block');
        if (block) {
          block.querySelectorAll('.option-value-btn').forEach(function (item) { item.classList.remove('active'); });
          button.classList.add('active');
          var chosen = block.querySelector('.option-chosen');
          if (chosen) chosen.textContent = button.dataset.value;
        }
        updateOptionAvailability();
        setVariant(findVariant());
      });
    });

    root.querySelectorAll('.thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.thumb').forEach(function (item) { item.classList.remove('active'); });
        thumb.classList.add('active');
        var mainImage = document.getElementById('mainImage-' + sectionId);
        if (mainImage && thumb.dataset.gallerySrc) mainImage.src = thumb.dataset.gallerySrc;
      });
    });

    var qty = form.querySelector('[data-qty-input]');
    var plus = form.querySelector('[data-qty-plus]');
    var minus = form.querySelector('[data-qty-minus]');
    if (plus && qty) plus.addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value || 1) + 1); });
    if (minus && qty) minus.addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value || 1) - 1); });

    form.addEventListener('submit', function (event) {
      var variant = findVariant();
      if (!variant || !variant.available || !window.CocoonHavenRoutes || !window.CocoonHavenRoutes.cartAdd) return;
      event.preventDefault();
      var button = document.getElementById('mainAtc-' + sectionId);
      if (button) { button.disabled = true; button.textContent = t.adding; }
      var quantity = Math.max(1, Number(qty && qty.value || 1));
      var bundle = form.querySelector('.bundle-check');
      var payload = { items: [{ id: variant.id, quantity: quantity }] };
      if (bundle && bundle.checked && bundle.dataset.bundleVariant && !bundle.disabled) payload.items.push({ id: Number(bundle.dataset.bundleVariant), quantity: 1 });

      fetch(window.CocoonHavenRoutes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      }).then(function () {
        if (button) { button.disabled = false; button.textContent = t.added; }
        showCartNotice();
        refreshCartCount();
        setTimeout(function () { if (button) button.textContent = t.addToCart; }, 1400);
      }).catch(function () {
        if (button) { button.disabled = false; button.textContent = t.addToCart; }
        HTMLFormElement.prototype.submit.call(form);
      });
    });

    var mainAtc = document.getElementById('mainAtc-' + sectionId);
    var sticky = document.getElementById('stickyAtc-' + sectionId);
    var stickyButton = sticky && sticky.querySelector('[data-sticky-submit]');
    if (mainAtc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { sticky.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(mainAtc);
    }
    if (stickyButton) stickyButton.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else mainAtc.click(); });

    updateOptionAvailability();
    setVariant(findVariant());
  });

  function showCartNotice() {
    var notice = document.getElementById('cartNotice');
    if (!notice) return;
    notice.classList.add('show');
    setTimeout(function () { notice.classList.remove('show'); }, 1800);
  }
  function refreshCartCount() {
    if (!window.CocoonHavenRoutes || !window.CocoonHavenRoutes.cart) return;
    fetch(window.CocoonHavenRoutes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
      .then(function (cart) { document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; }); })
      .catch(function () {});
  }
});
